export const Marquee = ({ items, className = "" }) => (
  <div className={`overflow-hidden border-y border-slate-200 bg-white py-5 ${className}`} data-testid="editorial-marquee">
    <div className="flex w-max animate-marquee">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex shrink-0 items-center" aria-hidden={copy === 1}>
          {items.map((item, i) => (
            <span key={i} className="flex items-center">
              <span className="px-8 font-mono text-xs tracking-[0.25em] uppercase text-slate-500 whitespace-nowrap">
                {item}
              </span>
              <span className="h-1.5 w-1.5 rotate-45 bg-sky-600/60 shrink-0" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
